import styled from "styled-components";

export const ULContainer = styled.div`
    height: 100vh;
    background-color: #4b80f3;
    background: -webkit-gradient(linear,left top,right top,from(#4b80f3),to(#8c69ca));
    background: linear-gradient(to right,#4b80f3,#8c69ca);
`;